<template>
  <app-collapse
    heading="Roles"
    :is-open="true"
  >
    <app-card
      variant="muted"
      body-class="space-y-6"
    >
      <template v-if="isLoading">
        <div class="flex flex-wrap gap-2">
          <div class="skeleton w-15 h-5 rounded-full!" />
          <div class="skeleton w-20 h-5 rounded-full!" />
          <div class="skeleton w-20 h-5 rounded-full!" />
        </div>
        <div class="skeleton w-full h-16.5 rounded-lg" />
      </template>
      <template v-else>
        <div class="space-y-3">
          <div class="flex flex-wrap gap-2">
            <app-badge
              v-for="role in userRoles"
              :key="role.id"
            >
              {{ role.name }}
            </app-badge>
          </div>
          <ul
            v-if="hasSingleRole"
            class="list-disc pl-4 text-sm text-gray-600"
          >
            <li>{{ UserRoleDescriptions[slugify(userRoles[0].name)] }}</li>
          </ul>
        </div>
        <button
          v-if="canChangeRole"
          :disabled="isLoading"
          class="btn btn-sm btn-secondary w-full"
          @click="updateUserRoleModalRef.showModal()"
        >
          Change role
        </button>
      </template>
    </app-card>
  </app-collapse>

  <update-user-role-modal
    ref="updateUserRoleModalRef"
    :user="user"
    :user-roles="userRoles"
  />
</template>

<script setup>
import { ref, computed } from 'vue';
import { useAuth0 } from '@auth0/auth0-vue';
import { slugify } from '@/utils/string';
import { useAuthStore } from '@/stores/auth';
import { UserRoleDescriptions } from '@/constants/users';
import UpdateUserRoleModal from '@/components/users/UpdateUserRoleModal.vue';

const props = defineProps({
  user: {
    type: Object,
    default: () => ({}),
  },
  userRoles: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
  isFetching: {
    type: Boolean,
    default: false,
  },
});

const { user: auth0User } = useAuth0();
const authStore = useAuthStore();
const updateUserRoleModalRef = ref(null);

const hasSingleRole = computed(() => props.userRoles.length === 1);

const isLoggedInUser = computed(() => props.user?.email === auth0User.value?.email);
const canChangeRole = computed(() => !isLoggedInUser.value && authStore.hasPermission('user:manage_roles'));
</script>
